import { buildProps, definePropType } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";

export const selectMoreProps = buildProps({
  modelValue: {
    type: Array,
  },
  list: {
    type: definePropType<Record<string, any>[]>(Array),
    default: () => [],
  },
  labelKey: {
    type: String,
    default: "text",
  },
  valueKey: {
    type: String,
    default: "id",
  },
  /** 是否启动筛选 */
  filterable: {
    type: Boolean,
    default: true,
  },
  /** 选项是否有最大宽度 */
  hasMax: {
    type: Boolean,
    default: true,
  },
  collapseTags: {
    type: Boolean,
    default: false,
  },
} as const);

export type SelectMoreProps = ExtractPropTypes<typeof selectMoreProps>;
